import { render, staticRenderFns } from "./allow-lists.vue?vue&type=template&id=0a11e1fd&"
import script from "./allow-lists.vue?vue&type=script&lang=js&"
export * from "./allow-lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports